import AddProductModal from './AddProductModal';
import EditProductModal from './EditProductModal';
import DeleteProductModal from './DeleteProductModal';
import CloneProductModal from './CloneProductModal';
import ImportProductsModal from './ImportProductsModal';
import DeploymentDetailsModal from './DeploymentDetailsModal';
import ConfirmModal from './ConfirmModal';
import AlertModal from './AlertModal';
import AddTagModal from './AddTagModal';

export {
    AddProductModal,
    EditProductModal,
    DeleteProductModal,
    CloneProductModal,
    ImportProductsModal,
    DeploymentDetailsModal,
    ConfirmModal,
    AlertModal,
    AddTagModal
};
